import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2d5736d2")

_pushScopeId("data-v-2d5736d2")
const _hoisted_1 = { class: "insurance-content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "insurance-header" }, [
  /*#__PURE__*/_createVNode("div", { class: "insurance-title" }, "项目"),
  /*#__PURE__*/_createVNode("div", { class: "insurance-title" }, "价格")
], -1)
const _hoisted_3 = { class: "insurance" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "insurance-item" }, "交强险", -1)
const _hoisted_5 = { class: "insurance-item" }
const _hoisted_6 = { class: "insurance" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "insurance-item" }, "车船税", -1)
const _hoisted_8 = { class: "insurance-item" }
const _hoisted_9 = { class: "insurance" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "insurance-item" }, "车损险", -1)
const _hoisted_11 = { class: "insurance-item" }
const _hoisted_12 = { class: "insurance" }
const _hoisted_13 = { class: "insurance-item" }
const _hoisted_14 = { class: "insurance-item" }
const _hoisted_15 = { class: "insurance" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "insurance-item" }, "车上人员责任险", -1)
const _hoisted_17 = { class: "insurance-item" }
const _hoisted_18 = { class: "insurance" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "insurance-item" }, "车险专享优惠", -1)
const _hoisted_20 = { class: "insurance-item" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "insurance-desc" }, " 以上保费为系统预估价格，实际以保险公司报价为准 ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, _toDisplayString(_ctx.grossFilter(_ctx.activeQuoteItem.trafficInsurance)) + "元", 1)
    ]),
    _createVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode("div", _hoisted_8, _toDisplayString(_ctx.grossFilter(_ctx.activeQuoteItem.carShipTax)) + "元", 1)
    ]),
    _createVNode("div", _hoisted_9, [
      _hoisted_10,
      _createVNode("div", _hoisted_11, _toDisplayString(_ctx.grossFilter(_ctx.activeQuoteItem.carDamageInsurance)) + "元 ", 1)
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode("div", _hoisted_13, " 第三者责任险 (" + _toDisplayString(_ctx.grossFilter(_ctx.activeQuoteItem.thirdPartyLiabilityQuota)) + "万） ", 1),
      _createVNode("div", _hoisted_14, _toDisplayString(_ctx.activeQuoteItem.thirdPartyLiabilityInsurance) + "元 ", 1)
    ]),
    _createVNode("div", _hoisted_15, [
      _hoisted_16,
      _createVNode("div", _hoisted_17, _toDisplayString(_ctx.grossFilter(_ctx.activeQuoteItem.personLiabilityInsurance)) + "元 ", 1)
    ]),
    _createVNode("div", _hoisted_18, [
      _hoisted_19,
      _createVNode("div", _hoisted_20, " -" + _toDisplayString(_ctx.grossFilter(_ctx.activeQuoteItem.carInsurancePolicy)) + "元 ", 1)
    ]),
    _hoisted_21
  ]))
})